module.exports = __webpack_public_path__ + "8966dfe1afded04e8bd6058634d6fb26.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/background.jpg
// module id = 563
// module chunks = 0